export { default } from './MultiFileDropzone';
